export default "__VITE_PUBLIC_ASSET__e17e4595__"